var image_viewer_rtlignore_default = {
  "fontElementMap": "_1Qsex",
  "imageContainer": "CQCKX",
  "expandContainer": "aZ9aJ",
  "expandIcon": "YAwfI",
  "pointer": "TI1RX",
  "imageWrapper": "e1h4z",
  "imageRatio": "V8Ei5",
  "image": "aNdQw",
  "imageOverlay": "_3CgjP",
  "imagePreload": "k-Xo2",
  "imageHighres": "H-8DM",
  "onlyHighRes": "_4b1d5",
  "image_loading": "O0hTs"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
